import React, { useState, useEffect } from 'react'
import authApiService from '../../../services/authServices';
import DataTable from 'react-data-table-component';
import { useSearchParams } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner';


const ViewSeason = () => {

  const [matches, setMatches] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchParams] = useSearchParams();
  const MRId = searchParams.get("id");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchMatches();
  }, []);

  const fetchMatches = async () => {
    setLoading(true);
    try {
      const response = await authApiService.get('scheduleViewForAdminData', { "id": MRId });
      console.log("viewseason", response)
      setMatches(response?.data || []);
    } catch (error) {
      console.error('Error fetching match data:', error);
    } finally {
      setLoading(false); // End loading
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const columns = [
    {
      name: 'Home Player',
      selector: (row) => `${row.golfer1_firstname} ${row.golfer1_lastname}`,
      sortable: true,
    },
    {
      name: 'Away Player',
      selector: (row) => `${row.golfer2_firstname} ${row.golfer2_lastname}`,
      sortable: true,
    },
    {
      name: 'Play By',
      selector: (row) => formatDate(row.play_by),
      sortable: true,
    },
    {
      name: 'Played',
      selector: (row) => formatDate(row.played),
      sortable: true,
    },

  ];

  const customStyles = {
    table: {
      style: {
        border: "1px solid #ddd",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#343a40",
        color: "#ffffff",
      },
    },
    rows: {
      style: {
        "&:nth-of-type(odd)": {
          backgroundColor: "#dedfdd",
        },
        "&:nth-of-type(even)": {
          backgroundColor: "#ffffff",
        },
      },
    },
  };

  // Filtered matches based on search term (searches across player names, dates and record text)
  const filteredMatches = matches.filter((row) => {
    if (!searchTerm) return true;

    const text =
      `${row.golfer1_firstname || ""} ${row.golfer1_lastname || ""} ` +
      `${row.golfer2_firstname || ""} ${row.golfer2_lastname || ""} ` +
      `${formatDate(row.play_by) || ""} ${formatDate(row.played) || ""}` +
      `${row.season_name || ""} ${row.record || ""}`;

    return text.toLowerCase().includes(searchTerm.toLowerCase());
  });


  return (
    <div className="page-container col-sm-9 mb-5 pb-5">
      <h2 className='text-dark view-season-title'>View Season Schedule</h2>
      <div className="leader-tab-info mb-4">
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "300px" }}>
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#4fa94d"
              ariaLabel="three-dots-loading"
              visible={true}
            />
          </div>
        ) : (
          <>
            {/* Search box for season records */}
            <div className="mb-3 d-flex justify-content-end mobile-search-box">
              <input
                type="text"
                className="form-control"
                placeholder="Search season records..."
                style={{ maxWidth: "300px" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <DataTable
              columns={columns}
              data={filteredMatches}
              pagination
              highlightOnHover
              striped
              responsive
              customStyles={customStyles}
            />
          </>
        )}

      </div>
    </div>

  )
}

export default ViewSeason